import { Box, DialogTitle, Typography, useMediaQuery } from "@mui/material";
import { useStyles } from "./basket-content-style";
import { useTranslation } from "react-i18next";
import { theme } from "components/theme/theme";
import { Dialog, DialogActions, DialogContent } from "components";
import { BasketContent } from "./basket-content";
import { BasketAction } from "./basket-action";
import { ProductBasket } from "store/bookingJourney";
import { InstructionBanner } from "../nav-banner/instruction-banner";
import { enableInstructionBanner } from "utils/helpers";

type ContentProps = {
  open: boolean;
  handleClose: () => void;
  products: ProductBasket[];
};
export const BasketContentDialog: React.FC<ContentProps> = ({ open, handleClose, products }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const onClose = () => {
    handleClose();
  };

  return (
    <Dialog
      id="yourCart"
      onClose={() => onClose()}
      role="dialog"
      open={open}
      minWidth={isMobile ? 0 : 396}
      showCloseIcon
      style={{ position: "absolute" }}
      maxHeight={isMobile ? 0 : 382}
      aria-modal="true"
      className={classes.root}
      aria-labelledby="title"
      title={t("your_basket")}
    >
      <DialogTitle
        role="status"
        aria-atomic="true"
        aria-live="assertive"
        className={classes.dialogTitle}
      >
        <Box id="title">{t("your_basket")}</Box>
      </DialogTitle>
      <DialogContent>
        {products?.length > 0 ? (
          <>
            <BasketContent products={products}></BasketContent>
          </>
        ) : (
          <Typography>{t("empty_basket")}</Typography>
        )}
      </DialogContent>
      {enableInstructionBanner() && products?.length > 0 && <InstructionBanner></InstructionBanner>}
      {products?.length > 0 && (
        <DialogActions className={classes.dialogAction}>
          <BasketAction
            products={products}
            handleClose={handleClose}
            isMobile={false}
            setbasketContentDrawerOpen={null}
          ></BasketAction>
        </DialogActions>
      )}
    </Dialog>
  );
};
